import { render, staticRenderFns } from "./EditClass.vue?vue&type=template&id=45aac91e"
import script from "../../services/teacher/edit-class.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/edit-class.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports